var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name != 'index')?_c('header-app'):_vm._e(),_c('router-view'),(_vm.$route.name != 'index')?_c('footer-app'):_vm._e(),_c('alert'),(_vm.isLogged)?_c('perfil-menu'):_vm._e(),(_vm.completeProfile & _vm.$route.name != 'completa-tu-perfil')?_c('popup-complete'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }